<template>
  <b-row>
    <b-col class="col-lg-6 offset-lg-3 col-sm-12">
      <div>
        <p class="lead text-center">You have been logged out. Thank you.</p>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'

export default {
  created: function () {
    this.logOutMethod()
  },
  computed: mapState([
    'logOut'
  ]),
  methods: {
    logOutMethod () {
      this.$store.dispatch('logOut')
    }
  }
}
</script>
